import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { FundraisingAccessItem } from "../../../../../../api/types/fundraisingTypes";

interface Props {
  onEditAccess: (row: FundraisingAccessItem) => void;
  onRemoveAccess: (row: FundraisingAccessItem) => void;
}

const FundraisingAccessGridContext = createContext<Props | undefined>(undefined);

export const FundraisingAccessGridContextProvider = ({
  onEditAccess,
  onRemoveAccess,
  children,
}: PropsWithChildren<Props>) => (
  <FundraisingAccessGridContext value={{ onEditAccess, onRemoveAccess }}>{children}</FundraisingAccessGridContext>
);

export default FundraisingAccessGridContext;
